export const MenuItemStyleSetter = (isEnglish) => {
  return !isEnglish
    ? {
        display: "flex",
        justifyContent: "space-between",
        direction: "rtl",
   
     
      }
    : {};
};
